import React from "react";
import "../styles/Spinner.css";

export default function Spinner() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
    </div>
  );
}
